"use client"

import { useState } from "react"
import "./UXFaq.css"

const faqData = [
  {
    question: "What is UX/UI design?",
    answer:
      "UX stands for user experience whereas UI stands for user interface. Given that they are two closely connected terms that frequently collaborate, you'll frequently find them grouped together.Simply put, UX design is the process of planning the experience a person has when interacting with a web app or site. The main goal of UX design is to make using these digital products and services easy, logical, and fun.On the other side, UI design is the user-centered method of creating a digital product's aesthetics. In essence, UI designers design create the look & feel of a website or application. These interfaces should not only be useful but also simple to use and attractive to the eye. The visual touchpoints that enable people to engage with a product are the main focus of UI designers. Typography, color schemes, buttons, motion, and other visuals can all fall under this category. Consider all the actions you might take on an app, such as slide to delete, pull down to reload, text entry, etc. It is necessary to develop every single graphic component or animation that makes it possible for you to use the app.",
  },
  {
    question: "Why do you need UX experts team?",
    answer:
      "The team evaluates your product’s quality and improves it based on your users’ needs and industries best practices.",
  },
  {
    question: "What are the benefits of UX audit?",
    answer:
      "UX Audit questions: get to know all the answers with Imaginary CloudThere are many (and valuable) benefits to conducting a UX Audit. Overall, it is a great way to optimize conversions and reduce the complexity of a digital product. Further, a UX Audit will help streamline goals and remove redundancies, leading the way to an enhanced user experience while saving time and money.Here are the four top benefits:• More streamlined products• Increased conversions and performance metrics• Better user experience• Improved user satisfaction and engagement",
  },
]

const ScopingFAQ = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section9922">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">UX AUDIT</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingFAQ;
